import { usePagination } from "react-instantsearch";
import Link from "@components/core/Link";

const CatalogPaginationTens = () => {
  const { nbPages, createURL } = usePagination();

  const renderTens = () => {
    if (nbPages < 10) return null;

    const pageLinks = [];

    for (let i = 9; i <= nbPages; i += 10) {
      pageLinks.push(
        <Link
          key={i}
          data-testid={`page-${i + 1}`}
          href={createURL(i)}
        >
          {(i + 1).toString()}
        </Link>,
      );
    }

    return pageLinks;
  };

  return renderTens();
};

export default CatalogPaginationTens;
